export default function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_has.js
// module id = Z3Wv
// module chunks = 0